<template>
  <div>
  	<div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-arrow-swap"></i>
        <div class="mg-l-20">
          <h4>{{$t("mall.售后订单")}}
          </h4>
        </div>
      </div>
      <div class="tx-right">
        
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30">
      <div class="clear-key">
        <a v-show="key_distributorName" href="javascript:;" class=" mg-r-15" @click="clearKey('distributorName')">
          {{$t("mall.客户名：")}}
          <span class="mg-r-10">{{key_distributorName}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_status" href="javascript:;" class=" mg-r-15" @click="clearKey('status')">
          {{$t("mall.状态：")}}
          <span class="mg-r-10">{{$t(payStatus[key_status])}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_code" href="javascript:;" class=" mg-r-15" @click="clearKey('code')">
          {{$t("mall.系统交易号：")}}
          <span class="mg-r-10">{{key_code}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_ordercode" href="javascript:;" class=" mg-r-15" @click="clearKey('orderCode')">
          {{$t("mall.订单号：")}}
          <span class="mg-r-10">{{key_ordercode}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_tradecode" href="javascript:;" class=" mg-r-15" @click="clearKey('tradeCode')">
          {{$t("mall.支付平台交易号：")}}
          <span class="mg-r-10">{{key_tradecode}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="date_from || date_to" href="javascript:;" class=" mg-r-15" @click="clearKey('date')">
         {{$t("mall.交易日期：")}} 
          <span class="mg-r-10">{{date_from}} {{$t("mall.至")}} {{date_to}}</span>
          <i class="fa fa-close"></i>
        </a>
        <a v-show="key_type" href="javascript:;" class=" mg-r-15" @click="clearKey('type')">
          {{$t("mall.类型：")}}
          <span class="mg-r-10">{{$t(payTypeArr[key_type])}}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>  
  </div>  
</template>

<script>
export default {
  props: ['key_distributorId', 'key_distributorName', 'key_status', 'key_code','key_ordercode','key_tradecode','key_type',"date_from","date_to",],
  data(){
    return {
    	payTypeArr: arrDict.afterSaleType,
      payStatus: arrDict.accountStatus,
    }
  },        
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    showStatus(val){
      let t = '';
      this.returnStatus.forEach(e => {
        if(e.val == val) t = e.name;
      });
      return t;
    }
  }
}
</script>

<style lang="less" scoped>
.br-pagetitle i.fa{
  color: #17A2B8;
  font-size: 70px;
}
</style>

